import moment from "@/utils/moment";

const isSameDate = (A, B) => {
  return moment(A).isSame(moment(B), "day");
};

export default {
  isSameDate
};



// WEBPACK FOOTER //
// ./src/utils/helpers/dateHelper.js